module.exports = __webpack_public_path__ + "img/core-line.0a40308d.png";